/**
 * Lucide 全量图标索引（供 /icon-morph 浏览；morphicons 本身不含图标，只消费此类描边数据）。
 * 安装于 preview 的 lucide 包；不写入 iconfont registry。
 */
import { icons } from 'lucide';

/** @type {{ name: string, data: import('lucide').IconNode }[]} */
export const lucideIconEntries = Object.entries(icons)
  .map(([name, data]) => ({ name, data }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const lucideIconCount = lucideIconEntries.length;

export function filterLucideIcons(keyword) {
  const q = String(keyword || '').trim().toLowerCase();
  if (!q) return lucideIconEntries;
  return lucideIconEntries.filter(({ name }) => name.toLowerCase().includes(q));
}
